import { getTerminParams } from '../jsx/react-components/sale-form/subcomponents/saleFormFunctions';
import moment from 'moment/moment';
import { HookReadMoreActions } from './read-more';
import { cutBreadcrumbActiveItem } from './cut-breadcrumb'

const resizeObserver = new ResizeObserver((entries) => {

  let rightPanelWrapper = document.querySelector('.right-panel-wrapper')
  let trainingFixedPanel = document.querySelector('.training-fixed-right-panel')
  let summaryWrapper = document.querySelectorAll('.summary-wrapper')[1]
  let topAlertBox = document.querySelector('.top-box')
  let trainingHeaderHeight = entries[0].target.offsetHeight - 10
  cutBreadcrumbActiveItem();
  if (topAlertBox && window.innerWidth > 992) {
    trainingFixedPanel.setAttribute('style', 'top:' + (150 + topAlertBox.offsetHeight) + 'px')

    if ( summaryWrapper ) {
      summaryWrapper.setAttribute('style', 'top:' + (150 + topAlertBox.offsetHeight) + 'px')
    }

  }

  let brakepoint = window.matchMedia('(min-width: 1024px)')
  if (brakepoint.matches) {
    rightPanelWrapper.setAttribute('style', 'margin-top:-' + trainingHeaderHeight + 'px')
  } else {
    rightPanelWrapper.setAttribute('style', 'margin-top:unset;')
  }

})
if (document.querySelector('.training-header')) {
  resizeObserver.observe(document.querySelector('.training-header'))
}

window.addEventListener('HIDE_FORM', () => {
  toggleForm(false)
})

window.addEventListener('popstate', (event) => {
  switch (document.location.hash) {
    default:
      toggleForm(false)
      break
    case '#step1':
      toggleForm(true)
      break
    case '#step2':
      toggleForm(true)
      break
  }
})

document.addEventListener('DOMContentLoaded', () => {
  HookReadMoreActions();
  adjustProgramListPadding();

  const terminsSelect = document.querySelector('#termins-select')

  if (terminsSelect) {
    const url = new URL(window.location.href)
    const termin = url.searchParams.get('termin')

    if (termin !== null) {
      terminsSelect.value = termin
      handleTerminChange(terminsSelect)
    }

    terminsSelect.addEventListener('change', (event) => {
      handleTerminChange(terminsSelect)
    })

    let asignButton = document.querySelector('.assign-button .btn')

    asignButton.addEventListener('click', (event) => {
      toggleForm(true, 'step1')
    })

  }

})

function toggleForm (state, setHash) {
  let trainingContentContainer = document.querySelector('#page-content')
  let form = document.querySelector('#saleForm')
  if (state) {
    if(setHash){
      window.location.hash = setHash
    }
    trainingContentContainer.classList.add('hidden')
    form.classList.remove('hidden')
    form.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  } else {
    window.location.hash = ''
    trainingContentContainer.classList.remove('hidden')
    form.classList.add('hidden')
    trainingContentContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

function handleTerminChange (terminsSelect) {

  let termins = window.saleForm.termins
  let terminParams = getTerminParams(termins, terminsSelect.value);

  if ( terminParams === null ) {
    return;
  }

  let terminID = terminParams.id;
  const trainerExists = terminParams.trainer !== null;

  const terminPriceElement = document.querySelector('#termin-price')
  const terminTrainerName = document.querySelector('#trainer-name')
  const multidayLists = document.querySelectorAll('.days ul')
  const trainerBottomTitle = document.querySelector('#trainer-bottom-title')
  const trainerBottomJobTitle = document.querySelector('#trainer-bottom-job-title')
  const trainerBottomImg = document.querySelector('#trainer-bottom-img')
  const trainerBottomDesc = document.querySelector('#trainer-bottom-desc')
  const trainerBottomHref = document.querySelector('#trainer-bottom-href')

  const trainingProgramPdfLinkElement = document.querySelector('#training_program_pdf_link');

  const jobTitle = terminParams.trainer[0].sm_acf_fields.job_title;

  if(trainingProgramPdfLinkElement) {
    let link = "/wp-json/sm/v1/training-pdf?termin_id=<terminID>&training_id=<trainingID>"
    link = link.replace('<terminID>', terminID);
    link = link.replace('<trainingID>', window.saleForm.training_id);
    trainingProgramPdfLinkElement.href = link;
  }

  terminPriceElement.innerHTML = terminParams.price + ' zł'
  if(trainerExists) {
    for (const key in terminParams.trainer[0]) {
      if ( terminParams.trainer[0][key] === null || terminParams.trainer[0][key] === undefined) {
        terminParams.trainer[0][key] = '';
      }
    }

    terminTrainerName.innerHTML = terminParams.trainer[0].sm_title

    //Trener stopka
    trainerBottomTitle.innerHTML = terminParams.trainer[0].sm_title
    trainerBottomImg.src = terminParams.trainer[0].sm_acf_fields.picture
    trainerBottomDesc.innerHTML = terminParams.trainer[0]['sm_content']
    trainerBottomJobTitle.innerHTML = terminParams.trainer[0].sm_acf_fields.job_title
    trainerBottomHref.href = terminParams.trainer[0].sm_url

    //Trener mobilka
    terminTrainerName.setAttribute('href', terminParams.trainer[0].sm_url)
  }
  if (multidayLists.length !== 0) {
    for (const multidayList of multidayLists) {
      multidayList.style.display = 'none'
      const listId = multidayList.getAttribute('id')
      if (parseInt(listId) === terminParams.id) {
        multidayList.style.display = 'block'
      }
    }
  }

  // Zmiana wybranego terminu w formularzu
  let TerminChangeEvent = new CustomEvent('TERMIN_CHANGE_EVENT', {
    'detail': {
      termin: terminsSelect.value,
    }
  })
  window.dispatchEvent(TerminChangeEvent)
}

const adjustProgramListPadding = () => {
  
  const list = document.querySelector('.training-program-content > ol');
  const listLength = document.querySelectorAll('.training-program-content > ol > li').length;

  if ( !list ) {
    return;
  }

  listLength > 27 && list.style.setProperty('--dynamic-ol-padding', '4rem');
  listLength > 90 && list.style.setProperty('--dynamic-ol-padding', '5rem');

}